import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { Col, Row } from 'elements'
import { formSubmit } from 'utils/form'
import { createClientConfig, listClients } from 'redux/modules/model/client'
import { clientsSelector } from 'redux/selectors'
import { ClientConfigForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-invite'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class ClientConfigAdd extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    createClientConfig: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, listClients } = this.props
    listClients({ clientId })
  }

  handleSubmit = (values) => {
    const { clientId, history, createClientConfig } = this.props
    return formSubmit(createClientConfig, { ...values })
      .then(() => history.push(ROUTES.CLIENT_CONFIG))
  };

  render() {
    const { clientList } = this.props
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.CLIENT_CONFIG}>&laquo; Back</Link></p>
          <PageContentTitle>Add a new client config</PageContentTitle>
          <ClientConfigForm onSubmit={this.handleSubmit} clients={clientList}/>
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  clientList: clientsSelector
})

export const actions = {
  createClientConfig,
  listClients
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(ClientConfigAdd)



// WEBPACK FOOTER //
// ./src/pages/client-config/clientconfig-add/index.js